
import React, { useState } from 'react';
import { usePhemexLang } from '@/contexts/PhemexLangContext';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';

const FaqSection = () => {
  const { t } = usePhemexLang();
  const [openItems, setOpenItems] = useState<Record<number, boolean>>({});
  
  const faqs = [
    {
      question: t.faq.question1.question,
      answer: t.faq.question1.answer
    },
    {
      question: t.faq.question2.question,
      answer: t.faq.question2.answer
    },
    {
      question: t.faq.question3.question,
      answer: t.faq.question3.answer
    },
    {
      question: t.faq.question5.question,
      answer: t.faq.question5.answer
    },
    {
      question: t.faq.question6.question,
      answer: t.faq.question6.answer
    }
  ];

  const toggleItem = (index: number) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="py-16 px-4 bg-gray-900">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-white">
          {t.faq.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.faq.subtitle}
        </p>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Collapsible
              key={index}
              open={openItems[index]}
              onOpenChange={() => toggleItem(index)}
              className="border border-gray-800 rounded-lg overflow-hidden bg-black"
            >
              <CollapsibleTrigger className="flex justify-between items-center w-full p-6 text-left focus:outline-none">
                <h3 className="text-lg font-semibold text-white">{faq.question}</h3>
                {openItems[index] ? (
                  <ChevronUp size={20} className="text-gray-400" />
                ) : (
                  <ChevronDown size={20} className="text-gray-400" />
                )}
              </CollapsibleTrigger>
              <CollapsibleContent className="px-6 pb-6 text-gray-300 border-t border-gray-800 pt-4">
                <p>{faq.answer}</p>
              </CollapsibleContent>
            </Collapsible>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
